import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/** Gate a route by one or more permission codes (all required). */
export default function RequirePermission({ permission, children, fallback = '/' }) {
  const { can, restoring } = useAuth();
  const codes = Array.isArray(permission) ? permission : [permission];

  if (restoring) return null;
  if (!codes.every((code) => can(code))) {
    return <Navigate to={fallback} replace />;
  }
  return children;
}
